import React from "react";

const AtIconPlay = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="50%"
      height="50%"
      fill="none"
      viewBox="0 0 113 131"
    >
      <path
        fill="#F05223"
        stroke="#fff"
        d="M109.109 60.397a5.618 5.618 0 0 1 2.113 2.128 6.04 6.04 0 0 1 .778 2.973 6.039 6.039 0 0 1-.778 2.974 5.617 5.617 0 0 1-2.113 2.128L9.647 129.201C5.807 131.47 1 128.638 1 124.105V6.892c0-4.527 4.806-7.36 8.647-5.096l99.462 58.6Z"
      />
    </svg>
  );
};

export default AtIconPlay;
